import { PanelPlacement } from '@ContractBuilder/hooks';
import type { MotionProps } from 'motion/react';

export const getAnimationProps = (placement: PanelPlacement): MotionProps => {
  const isLeftSide = placement === PanelPlacement.Left;
  const XOffset = isLeftSide ? '-100%' : '100%';

  return {
    animate: { x: 0 },
    exit: { x: XOffset },
    initial: { x: XOffset },
    transition: { duration: 0.3, ease: 'easeInOut' },
  };
};

export const splitPaneAnimationProps: MotionProps = {
  animate: { x: 0 },
  exit: { x: '-100%' },
  initial: { x: '-100%' },
  transition: { duration: 0.3, ease: 'easeInOut' as const },
};

export const DOCUMENT_PADDING_PX = 27;
export const MAX_WIDTH_OFFSET_PX = 320;
export const DEFAULT_WIDTH = 600;

export const CONTRACT_COMPARISON_TAB_ID = 'contract-comparison' as const;
